import { action, observable, ObservableMap } from 'mobx';

import { plotOrderKeys } from './quiz-results-store';

type PlotKey = string;

/**
 * State of which plots (current expected etc) are hidden - default: actual/expected showing
 */
export class PlotKeyToggleState {
  private readonly plotkeysHidden: ObservableMap<string, boolean>;

  // since it refers to an unspecified range of PlotKey values - it marks only those that are
  // hidden and everything else is implicitly shown.

  constructor() {
    this.plotkeysHidden = observable.map<string, boolean>(
      // The plot elements that we know exist
      //FF2-429 Ensure that "industry" and "group" are toggled hidden at first without good reason
      new Map([
        [plotOrderKeys.actual, false],
        [plotOrderKeys.expected, false],
        [plotOrderKeys.previous, true],
        [plotOrderKeys.group, true],
        [plotOrderKeys.industry, true]
      ])
    );
  }

  isShown(key: PlotKey): boolean {
    const isHidden = this.plotkeysHidden.get(key);
    if (isHidden !== undefined) {
      return !isHidden;
    }
    return true;
  }

  /// Toggle visibility of given plot key
  @action toggle(key: PlotKey) {
    if (!this.plotkeysHidden.has(key)) {
      this.plotkeysHidden.set(key, false);
    }
    if (!this.onlyKeyIsShowing(key)) {
      this.plotkeysHidden.set(key, this.isShown(key));
    }
  }

  onlyKeyIsShowing(key: PlotKey): boolean {
    for (const k of this.plotkeysHidden.keys()) {
      if (key !== k && this.isShown(k)) {
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/stores/plot-key-toggle-state.ts